var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "center" },
      [
        _vm.showDialog
          ? _c("krryPaging", {
              ref: "paging",
              attrs: {
                "selected-data": _vm.selectedData,
                "page-size": 10,
                "box-title": _vm.boxTitle,
                filterable: true,
                "filter-placeholder": [
                  "请输入左侧接口地址",
                  "请输入右侧接口地址"
                ],
                "page-texts": ["上一页", "下一页"],
                sort: false,
                async: true,
                "is-highlight": true,
                "get-page-data": _vm.getPageData,
                "get-search-data": _vm.getSearchData,
                "show-clear-btn": true
              },
              on: { onChange: _vm.onChangeData }
            })
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "dialog-footer",
        staticStyle: { "margin-top": "30px" },
        attrs: { slot: "footer" },
        slot: "footer"
      },
      [
        _c("el-button", { on: { click: _vm.handCancle } }, [
          _vm._v(_vm._s(_vm.$t("button.cancel")))
        ]),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
          [_vm._v(_vm._s(_vm.$t("button.confirm")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }